import { Link, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Alert from '/@/components/bayer/alert';
import { useUserLocations } from '/@/hooks/user';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';
import ProductCatalog from '../product-catalog';

const ProductsSection = ({
    setOpenLocationSelectorModal,
}: {
    setOpenLocationSelectorModal?: (open: boolean) => void;
}) => {
    const country = useSelector(getSessionCountry);
    const userLocationsQuery = useUserLocations({ level: 2, pageSize: 100000 }, { enabled: !!country });

    return (
        <Stack spacing={3} sx={{ flex: 1, width: '100%', minHeight: 0 }}>
            <Stack spacing={1}>
                <Typography color='primary' variant='h5'>
                    {_('Productos seleccionados')}
                </Typography>
                <Typography color='primary.mui.inactive' variant='body2'>
                    {_('Listado ajustado a la ubicación configurada y momento.')}
                </Typography>
            </Stack>
            {!userLocationsQuery.isValidating &&
                !userLocationsQuery.error &&
                userLocationsQuery.data?.results.length === 0 &&
                setOpenLocationSelectorModal && (
                    <Alert severity='danger'>
                        {_('Para ver productos segmentados por zona, agrega dónde se encuentran los productores.')}{' '}
                        <Link onClick={() => setOpenLocationSelectorModal(true)} sx={{ cursor: 'pointer' }}>
                            {_('Agregar ubicaciones')}
                        </Link>
                    </Alert>
                )}
            <Stack sx={{ flex: 1, minHeight: 0 }}>
                <ProductCatalog />
            </Stack>
        </Stack>
    );
};

export default ProductsSection;
